import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Goatonavimumbaicab() {



    const cardData = {
"keyword": "Goa to Navi Mumbai Cab",

"headingDescription":
  "Om Sai Cab offers reliable and comfortable Goa to Navi Mumbai Cab service for travelers looking for a safe, affordable, and convenient long-distance journey from Goa back to Navi Mumbai. Whether you are returning from a family vacation, honeymoon trip, friends getaway, beach holiday, sightseeing tour, or corporate travel, our taxi service ensures a smooth and stress-free travel experience from Goa to Navi Mumbai. With experienced drivers familiar with Konkan highway routes, clean air-conditioned vehicles maintained for long-distance comfort, and transparent pricing with no hidden charges, we provide a dependable one-way and round-trip travel solution for every traveler. Our fleet includes sedans, SUVs, Innova cars, tempo travellers, and premium vehicles suitable for solo travelers, families, and groups.",

"topPlaces": [
  {
    "title": "Palm Beach Road",
    "description": "A beautiful and wide coastal road in Navi Mumbai known for scenic drives, sea views, and peaceful evening walks."
  },
  {
    "title": "Belapur Fort",
    "description": "Historic fort in CBD Belapur offering a quiet atmosphere and a glimpse of Portuguese-era architecture."
  },
  {
    "title": "Kharghar Hills",
    "description": "Popular trekking and sunrise spot with panoramic views of Navi Mumbai and lush green surroundings."
  },
  {
    "title": "Central Park Kharghar",
    "description": "One of the largest parks in Navi Mumbai featuring open green spaces, jogging tracks, and musical fountains."
  },
  {
    "title": "ISKCON Kharghar",
    "description": "Beautiful temple dedicated to Lord Krishna known for its peaceful environment and spiritual vibes."
  },
  {
    "title": "Nerul Balaji Temple",
    "description": "Famous temple modeled after Tirupati Balaji, attracting devotees from across Navi Mumbai."
  },
  {
    "title": "Seawoods Grand Central",
    "description": "Modern shopping mall with premium brands, food courts, and entertainment options."
  },
  {
    "title": "DY Patil Stadium",
    "description": "World-class sports stadium hosting cricket, football, and major entertainment events."
  },
  {
    "title": "Utsav Chowk Kharghar",
    "description": "Iconic architectural landmark inspired by Roman design, known for its beautiful night lighting."
  },
  {
    "title": "Nerul Lake & Nature Park",
    "description": "Peaceful lake surrounded by greenery, ideal for relaxation, walking, and bird watching."
  }
],



services: [
  {
    name: "Goa to Navi Mumbai Cab",
    description: "Goa to Navi Mumbai cab service provides reliable long-distance transportation for travelers planning comfortable road journeys from Goa to Navi Mumbai. Vehicles ensure smooth highway travel suitable for tourism, family travel, business trips, and holiday return journeys. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from hotels, resorts, airports, railway stations, and nearby tourist areas across Goa. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Goa to Navi Mumbai Cab Service",
    description: "Goa to Navi Mumbai cab service offers dependable transportation solutions for travelers seeking safe and comfortable road travel to Navi Mumbai. Comfortable vehicles ensure reliable highway journeys suitable for tourism trips, sightseeing tours, and family vacations. Professional chauffeurs ensure punctual pickup and smooth transportation services throughout the route. Pickup services are available from hotels, resorts, beaches, airports, and railway stations across Goa. Flexible booking options allow convenient cab service reservations."
  },
  {
    name: "Goa to Navi Mumbai Taxi",
    description: "Goa to Navi Mumbai taxi service provides smooth and comfortable transportation for passengers planning direct road travel to Navi Mumbai. Vehicles ensure reliable highway journeys suitable for tourism travel, executive trips, and family holidays. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from hotels, resorts, airports, railway stations, and nearby locations across Goa. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Goa to Navi Mumbai Taxi Service",
    description: "Goa to Navi Mumbai taxi service offers premium transportation for travelers returning from Goa to Navi Mumbai with comfortable and spacious vehicles. Vehicles ensure smooth highway travel suitable for sightseeing tours, tourism travel, and long-distance family journeys. Professional chauffeurs ensure reliable pickup and punctual transportation services throughout the route. Pickup services are available from hotels, airports, resorts, railway stations, and nearby tourist areas across Goa. Flexible booking options allow convenient taxi service reservations."
  },
  {
    name: "Goa to Navi Mumbai One Way Cab",
    description: "Goa to Navi Mumbai one way cab service provides economical transportation for travelers requiring direct one-side travel from Goa to Navi Mumbai. Comfortable vehicles ensure smooth highway journeys suitable for tourists, couples, solo travelers, and family vacations. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from hotels, beaches, airports, resorts, and nearby locations across Goa. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Goa to Navi Mumbai Outstation Cab",
    description: "Goa to Navi Mumbai outstation cab service provides dependable long-distance transportation for comfortable intercity road journeys. Vehicles ensure reliable highway travel suitable for tourism travel, business trips, and family holidays. Professional chauffeurs ensure punctual pickup and smooth transportation services throughout the route. Pickup services are available from hotels, airports, resorts, railway stations, and nearby tourist areas across Goa. Flexible booking options allow convenient outstation cab reservations."
  },
  {
    name: "Goa to Navi Mumbai Innova Cab",
    description: "Goa to Navi Mumbai Innova cab service provides spacious transportation for families and groups planning comfortable road travel. Innova vehicles ensure smooth highway journeys with comfortable seating and luggage capacity suitable for long-distance travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from hotels, resorts, airports, railway stations, and nearby locations across Goa. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Goa to Navi Mumbai Airport Cab",
    description: "Goa to Navi Mumbai Airport cab service provides direct airport transportation for travelers planning comfortable road journeys from Goa to Navi Mumbai Airport. Vehicles ensure smooth highway travel with spacious seating and luggage space suitable for airport passengers. Professional chauffeurs ensure timely pickup and reliable transportation services throughout the route. Pickup services are available from hotels, resorts, airports, and nearby tourist areas across Goa. Flexible booking options allow convenient airport cab reservations."
  },
  {
    name: "Goa to Navi Mumbai Airport Taxi",
    description: "Goa to Navi Mumbai Airport taxi service offers dependable transportation for travelers requiring direct airport travel from Goa. Comfortable vehicles ensure reliable highway journeys suitable for tourism, executive travel, and family holidays. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from hotels, resorts, airports, railway stations, and nearby locations across Goa. Flexible booking options allow convenient airport taxi reservations."
  },
  {
    name: "Goa to Navi Mumbai Airport Cab Service",
    description: "Goa to Navi Mumbai Airport cab service provides premium transportation with comfortable vehicles for long-distance airport travel. Vehicles ensure smooth highway journeys suitable for tourism travel, airport transfers, and family trips. Professional chauffeurs ensure dependable pickup and reliable transportation services throughout the route. Pickup services are available from hotels, resorts, beaches, airports, and nearby tourist areas across Goa. Flexible booking options allow convenient airport cab service reservations."
  },
  {
    name: "Goa to Navi Mumbai Airport Drop Cab",
    description: "Goa to Navi Mumbai Airport drop cab service provides direct airport drop transportation for passengers planning comfortable travel to Navi Mumbai Airport. Vehicles ensure smooth highway journeys with spacious seating and luggage capacity suitable for airport passengers. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from hotels, resorts, airports, and nearby areas across Goa. Flexible booking options allow convenient airport drop cab reservations."
  },
  {
    name: "Goa to Navi Mumbai Airport Transfer Taxi",
    description: "Goa to Navi Mumbai Airport transfer taxi service offers dependable airport transportation with experienced chauffeurs and comfortable vehicles. Vehicles ensure reliable highway travel suitable for tourism trips, executive travel, and family journeys. Professional chauffeurs ensure timely pickup and safe transportation services throughout the route. Pickup services are available from hotels, resorts, airports, railway stations, and nearby tourist areas across Goa. Flexible booking options allow convenient airport transfer taxi reservations."
  },
  {
    name: "Goa to Navi Mumbai Airport One Way Cab",
    description: "Goa to Navi Mumbai Airport one way cab service provides economical transportation for travelers requiring direct one-side airport travel. Comfortable vehicles ensure smooth highway journeys suitable for tourists, solo travelers, couples, and family travel. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from hotels, resorts, beaches, airports, and nearby locations across Goa. Flexible booking options allow convenient airport one-way cab reservations."
  },
  {
    name: "Navi Mumbai Airport Innova Crysta",
    description: "Navi Mumbai Airport Innova Crysta service provides luxury transportation with premium interiors and spacious seating for comfortable airport road journeys. Innova Crysta vehicles are ideal for executive travel, tourism trips, family holidays, and VIP transportation. Professional chauffeurs ensure punctual pickup and premium transportation services throughout the route. Pickup services are available from hotels, airports, resorts, railway stations, and nearby areas across Goa. Flexible booking options allow convenient Innova Crysta reservations."
  },
  {
    name: "Goa to Navi Mumbai Airport Ertiga Cab",
    description: "Goa to Navi Mumbai Airport Ertiga cab service offers affordable and spacious transportation for small families and groups planning airport travel. Ertiga vehicles ensure smooth highway journeys suitable for tourism, family travel, and holiday return trips. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from hotels, resorts, airports, railway stations, and nearby tourist locations across Goa. Flexible booking options allow convenient Ertiga cab reservations."
  },
  {
    name: "Goa to Thane Cabs Service",
    description: "Goa to Thane cabs service provides dependable transportation for travelers planning comfortable road journeys from Goa to Thane. Vehicles ensure reliable highway travel suitable for tourism, family vacations, and business travel. Professional chauffeurs ensure safe driving and smooth transportation services throughout the route. Pickup services are available from hotels, resorts, airports, railway stations, and nearby locations across Goa. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Goa to Thane Cab",
    description: "Goa to Thane cab service offers comfortable transportation for travelers seeking direct road travel from Goa to Thane. Vehicles ensure smooth highway journeys suitable for tourism trips, sightseeing tours, and family holidays. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from hotels, resorts, airports, and nearby tourist areas across Goa. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Goa to Thane Taxi Service",
    description: "Goa to Thane taxi service provides reliable transportation for passengers planning smooth and safe road journeys to Thane. Comfortable vehicles ensure dependable highway travel suitable for tourism travel, family vacations, and executive trips. Professional chauffeurs ensure punctual pickup and reliable transportation services throughout the route. Pickup services are available from hotels, airports, resorts, railway stations, and nearby locations across Goa. Flexible booking options allow convenient taxi service reservations."
  },
  {
    name: "Goa to Thane One Way Cab",
    description: "Goa to Thane one way cab service provides economical transportation for travelers requiring direct one-side travel to Thane. Vehicles ensure smooth and reliable highway journeys suitable for tourists, solo travelers, couples, and family travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from hotels, resorts, beaches, airports, and nearby areas across Goa. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Goa to Thane Outstation Taxi",
    description: "Goa to Thane outstation taxi service provides dependable long-distance transportation for travelers planning comfortable intercity road journeys. Vehicles ensure reliable highway travel suitable for tourism, business trips, and family holidays. Professional chauffeurs ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from hotels, resorts, airports, railway stations, and nearby locations across Goa. Flexible booking options allow convenient outstation taxi reservations."
  },
  {
    name: "Goa to Thane Cab Booking",
    description: "Goa to Thane cab booking service offers easy transportation reservations for travelers planning smooth road journeys from Goa to Thane. Comfortable vehicles ensure reliable highway journeys suitable for tourism travel, sightseeing tours, and family vacations. Professional chauffeurs ensure dependable pickup and safe transportation services throughout the route. Pickup services are available from hotels, resorts, airports, and nearby tourist locations across Goa. Flexible booking options allow convenient cab booking reservations."
  },
  {
    name: "Goa to Thane Innova Cab",
    description: "Goa to Thane Innova cab service provides spacious transportation for families and groups planning comfortable road travel. Innova vehicles ensure smooth highway journeys with comfortable seating and luggage capacity suitable for long-distance journeys. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from hotels, airports, resorts, railway stations, and nearby locations across Goa. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Goa to Thane Sedan Taxi",
    description: "Goa to Thane sedan taxi service offers comfortable transportation for solo travelers, couples, and business passengers planning Thane road travel. Sedan vehicles ensure smooth and safe highway journeys suitable for tourism travel and executive trips. Professional chauffeurs ensure dependable pickup and reliable transportation services throughout the route. Pickup services are available from hotels, resorts, airports, railway stations, and nearby areas across Goa. Flexible booking options allow convenient sedan taxi reservations."
  },
  {
    name: "Goa to Panvel Cab",
    description: "Goa to Panvel cab service provides reliable transportation for travelers planning comfortable road journeys from Goa to Panvel. Vehicles ensure smooth highway travel suitable for tourism, family holidays, and executive travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from hotels, resorts, airports, railway stations, and nearby tourist areas across Goa. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Goa to Panvel Cab Service",
    description: "Goa to Panvel cab service offers dependable transportation solutions for travelers seeking direct and safe road travel to Panvel. Comfortable vehicles ensure reliable highway journeys suitable for tourism travel, family vacations, and business trips. Professional chauffeurs ensure punctual pickup and smooth transportation services throughout the route. Pickup services are available from hotels, airports, resorts, railway stations, and nearby locations across Goa. Flexible booking options allow convenient cab service reservations."
  }
],

tableData: [
  ["Goa to Navi Mumbai Cab", "Goa to Navi Mumbai Cab Service"],
  ["Goa to Navi Mumbai Taxi", "Goa to Navi Mumbai Taxi Service"],
  ["Goa to Navi Mumbai One Way Cab", "Goa to Navi Mumbai Outstation Cab"],
  ["Goa to Navi Mumbai Innova Cab", "Goa to Navi Mumbai Airport Cab"],
  ["Goa to Navi Mumbai Airport Taxi", "Goa to Navi Mumbai Airport Cab Service"],
  ["Goa to Navi Mumbai Airport Drop Cab", "Goa to Navi Mumbai Airport Transfer Taxi"],
  ["Goa to Navi Mumbai Airport One Way Cab", "Navi Mumbai Airport Innova Crysta"],
  ["Goa to Navi Mumbai Airport Ertiga Cab", "Goa to Thane Cabs Service"],
  ["Goa to Thane Cab", "Goa to Thane Taxi Service"],
  ["Goa to Thane One Way Cab", "Goa to Thane Outstation Taxi"],
  ["Goa to Thane Cab Booking", "Goa to Thane Innova Cab"],
  ["Goa to Thane Sedan Taxi", "Goa to Panvel Cab"],
  ["Goa to Panvel Cab Service", "Goa to Navi Mumbai Cab"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Goa to Navi Mumbai Cab Service",
    WhyChoosedescription: "Om Sai Cab Service provides reliable Goa to Navi Mumbai cab service with professional drivers, comfortable vehicles, and smooth long-distance travel for tourists, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Affordable Goa to Navi Mumbai Taxi Fare",
    WhyChoosedescription: "Our Goa to Navi Mumbai taxi service offers affordable pricing with transparent fare details and no hidden charges for one-way and round-trip travel bookings."
  },
  {
    WhyChooseheading: "24/7 Goa to Navi Mumbai Cab Availability",
    WhyChoosedescription: "Om Sai Cab Service operates 24 hours a day for Goa to Navi Mumbai cab bookings including airport transfers, hotel pickups, family vacations, and emergency travel."
  },
  {
    WhyChooseheading: "Comfortable AC Cabs for Long Distance Travel",
    WhyChoosedescription: "All Goa to Navi Mumbai taxis are fully air-conditioned, sanitized, spacious, and maintained regularly for smooth and comfortable highway journeys."
  },
  {
    WhyChooseheading: "One Way & Round Trip Taxi Booking",
    WhyChoosedescription: "Customers can choose one-way Goa to Navi Mumbai cab service, round-trip bookings, return travel options, and customized outstation travel packages."
  },
  {
    WhyChooseheading: "Wide Range of Cab Vehicle Choices",
    WhyChoosedescription: "Om Sai Cab Service offers sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers suitable for solo travelers, families, and group tours."
  },
  {
    WhyChooseheading: "Pickup from North Goa, South Goa & Airport",
    WhyChoosedescription: "We provide pickup service from Panaji, Calangute, Baga, Candolim, Vasco, Madgaon, Goa Airport, hotels, resorts, and all major Goa tourist locations."
  },
  {
    WhyChooseheading: "Experienced Drivers for Navi Mumbai Routes",
    WhyChoosedescription: "Our experienced drivers are familiar with Goa to Navi Mumbai highway routes and ghat sections, ensuring safe driving, smooth travel, and timely arrival."
  }
]
};

const faqData = [
  {
    question: "What is Goa to Navi Mumbai cab service?",
    answer: "Goa to Navi Mumbai cab service provides comfortable taxi transportation from Goa to Navi Mumbai for tourism, family travel, airport transfers, and outstation journeys."
  },
  {
    question: "Is Goa to Navi Mumbai cab service available 24 hours?",
    answer: "Yes, Om Sai Cab Service provides 24/7 Goa to Navi Mumbai taxi service."
  },
  {
    question: "Which vehicles are available for Goa to Navi Mumbai travel?",
    answer: "Customers can choose sedan taxis, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers."
  },
  {
    question: "Can I book a one-way cab from Goa to Navi Mumbai?",
    answer: "Yes, one-way as well as round-trip Goa to Navi Mumbai cab bookings are available."
  },
  {
    question: "Do you provide pickup from Goa Airport and hotels?",
    answer: "Yes, pickup service is available from Goa Airport, hotels, resorts, railway stations, and all major Goa tourist locations."
  },
  {
    question: "Are all Goa to Navi Mumbai taxis air-conditioned?",
    answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable long-distance travel."
  },
  {
    question: "Can I book Goa to Navi Mumbai cab service online?",
    answer: "Yes, customers can easily book Goa to Navi Mumbai cab service online or through phone booking."
  },
  {
    question: "Do you provide Innova Crysta taxi service from Goa to Navi Mumbai?",
    answer: "Yes, premium Innova Crysta cab service is available for Goa to Navi Mumbai travel."
  },
  {
    question: "Are Goa to Navi Mumbai cab fares transparent?",
    answer: "Yes, Om Sai Cab Service provides affordable and transparent pricing without hidden charges."
  },
  {
    question: "Is advance booking available for Goa to Navi Mumbai cabs?",
    answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak tourist seasons."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Yogesh Kadam",
    feedback: "Booked Om Sai Cab Service for our Goa to Navi Mumbai journey and had a very smooth experience. The driver was experienced and ensured a safe and comfortable long-distance ride.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Shweta Naik",
    feedback: "Our return trip from Goa to Navi Mumbai was handled very well by Om Sai Cab Service. The cab was clean, the pickup was on time, and the entire journey felt relaxed and secure.",
    rating: 5
  }
];

















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai to Goa Cab", link: "Mumbai-to-Goa-Cab" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Goa Cab Booking", link: "Mumbai-to-Goa-Cab-Booking" },
        { place: "/images/keyword/3.jpg", text: "Navi Mumbai to Goa Cab Service", link: "Navi-Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/4.jpg", text: "Mumbai Airport to Goa Cab", link: "Mumbai-Airport-to-Goa-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Goa Cab Service", link: "Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Best Mumbai to Goa Cab Service", link: "Best-Mumbai-to-Goa-Cab-Service" },
        { place: "/images/keyword/7.jpg", text: "Thane to Goa Cabs", link: "Thane-to-Goa-Cabs" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Goa Innova Crysta Cab", link: "Mumbai-to-Goa-Innova-Crysta-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Goa One Way Cab", link: "Mumbai-to-Goa-One-Way-Cab" },
        { place: "/images/keyword/10.jpg", text: "Goa Cabs Service", link: "Goa-Cabs-Service" },
        { place: "/images/keyword/11.jpg", text: "Goa to Mumbai Cab", link: "Goa-to-Mumbai-Cab" },
        { place: "/images/keyword/12.jpg", text: "Goa to Navi Mumbai Cab", link: "Goa-to-Navi-Mumbai-Cab" },
        { place: "/images/keyword/13.jpg", text: "Goa to Mumbai Airport Cab", link: "Goa-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/14.jpg", text: "Goa to Mumbai One Way Cab", link: "Goa-to-Mumbai-One-Way-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/16.jpg", text: "Lonavala to Mumbai Cab", link: "Lonavala-to-Mumbai-Cab" },
        { place: "/images/keyword/17.jpg", text: "Best Lonavala to Navi Mumbai Cab", link: "Best-Lonavala-to-Navi-Mumbai-Cab" },
        { place: "/images/keyword/18.jpg", text: "Navi Mumbai Airport Cab", link: "Navi-Mumbai-Airport-Cab" },
        { place: "/images/keyword/19.jpg", text: "Navi Mumbai Cab Service", link: "Navi-Mumbai-Cab-Service" },
        { place: "/images/keyword/20.jpg", text: "Kharghar Taxi Services", link: "Kharghar-Taxi-Services" },
        { place: "/images/keyword/21.jpg", text: "Mumbai Airport Cabs", link: "Mumbai-Airport-Cabs" },
        { place: "/images/keyword/22.jpg", text: "Mumbai Cab Service", link: "Mumbai-Cab-Service" },
        { place: "/images/keyword/23.jpg", text: "Mumbai Online Cab Service", link: "Mumbai-Online-Cab-Service" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/25.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/26.jpg", text: "Innova Crysta On Rent in Mumbai", link: "Innova-Crysta-On-Rent-in-Mumbai" },
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Goa to Navi Mumbai Cab Service",
  "image": "http://www.omsaicabservice.com/assets/images/goa-to-navi-mumbai-cab.jpg",
  "description": "Book Goa to Navi Mumbai cab service with Om Sai Cab Service for one-way and outstation travel. Affordable Sedan, SUV, Innova, Innova Crysta, and airport transfer taxis available for Goa to Navi Mumbai and airport drop services with 24x7 support.",
  "brand": {
    "@type": "Brand",
    "name": "Om Sai Cab Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "http://www.omsaicabservice.com/goa-to-navi-mumbai-cab"
  }
};





    return (
        <div>

<Helmet>
  <title>
    Goa to Navi Mumbai Cab Service | One Way & Airport Taxi | +91 9594849797
  </title>

  <meta
    name="description"
    content="Book Goa to Navi Mumbai cab service at affordable fares. One-way cab, outstation taxi, Innova, SUV, and airport transfer services available for Goa to Navi Mumbai and airport drop taxi booking with 24x7 support."
  />

  <meta
    name="keywords"
    content="Goa to Navi Mumbai Cab, Goa to Navi Mumbai Cab Service, Goa to Navi Mumbai Taxi, Goa to Navi Mumbai Taxi Service, Goa to Navi Mumbai One Way Cab, Goa to Navi Mumbai Outstation Cab, Goa to Navi Mumbai Innova Cab, Goa to Navi Mumbai Airport Cab, Goa to Navi Mumbai Airport Taxi, Goa to Navi Mumbai Airport Cab Service, Goa to Navi Mumbai Airport Drop Cab, Goa to Navi Mumbai Airport Transfer Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcrumb-bar">
                <div className="container">
                    <div className="row align-items-center text-center">
                        <div className="col-md-12 col-12">
                            <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/12.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FFCC00', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Om Sai Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Om Sai Cab</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Om Sai Cab </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                             <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919594849797" className="pc-call">+91 9594849797</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919594849797"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919594849797" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@omsaicabservice.com" className="pc-email">
                                            booking@omsaicabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Om Sai Cab Service</strong><br />
                                            Shree Vishal CHS Ltd., Plot No.17,
                                            Sector 18, Kopar Khairane, Navi Mumbai,
                                            Maharashtra- India - 400709
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Goatonavimumbaicab;